var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 8,
  fill: "#FF5959",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("text", {
  fill: "#FFF",
  fontFamily: "AvertaPE-Bold, Averta PE",
  fontSize: 14,
  fontWeight: "bold"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 5.71428571,
  y: 13
}, `!`)))));
export default __webpack_public_path__ + "static/media/warning.71232ede.svg";
export { SvgComponent as ReactComponent };